export default __webpack_public_path__ + "static/media/admin-background.952eca1d.svg";